import { useState, useEffect } from "react";
import { DropdownButton, Dropdown, Accordion, Form } from "react-bootstrap";
import NoData from "../../components/NoData";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL, HEADERS } from "../../utils/constant";
import ExportModal from "../../components/Modals/ExportsModel/main";
import ImportModal from "../../components/Modals/ImportModel";
import Loader from "../../components/Loader";
import { MdCancel, MdCheckCircle } from "react-icons/md";
import { BsThreeDotsVertical } from "react-icons/bs";
import {
  FaEdit,
  FaFileExport,
  FaFileImport,
  FaPlus,
  FaTrashAlt,
  FaUserCircle,
} from "react-icons/fa";
import { useCommonContext } from "../../utils/context";
import TechnicianViewModal from "../../components/Modals/HisstoryModals/UserViewModel";
import AgentModal from "../../components/Modals/AgentModel";
import CommonButton from "../../components/CommonButton";
import Pagination from "../../components/Pagination";

const Technician = () => {
  const [showTechnicianModal, setShowTechnicianModal] = useState(false);
  const [showImportModal, setShowImportModal] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [technicians, setTechnicians] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editTechnicianData, setEditTechnicianData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [selectedTechnicians, setSelectedTechnicians] = useState([]);
  const role = localStorage.getItem("role");
  const [exportLoading, setExportLoading] = useState(false);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [statusFilter, setStatusFilter] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = technicians;
  const [showViewModal, setShowViewModal] = useState(false);
  const { fetchTechnicians: fetchActiveTechnicians } = useCommonContext();

  useEffect(() => {
    fetchTechnicians(currentPage);
  }, [currentPage, itemsPerPage, searchText, statusFilter]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchText]);

  const fetchTechnicians = async (page = 1) => {
    setLoading(true);
    try {
      let url = `${BASE_URL}/users/tms_users/`;
      if (statusFilter === false) {
        url = `${BASE_URL}/users/tms_users/deactivate-users/`;
      }

      const response = await axios.get(url, {
        headers: HEADERS,
        params: {
          role: "technician",
          page: page,
          page_size: itemsPerPage,
          search: searchText || undefined,
          ...(statusFilter !== false && {
            is_active: statusFilter !== null ? statusFilter : undefined,
          }),
        },
      });

      if (response.data?.results) {
        setTechnicians(response.data.results);
        setTotalPages(response.data.total_pages);
        setCurrentPage(page);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const handleEditTechnician = (technician) => {
    setEditTechnicianData(technician);
    setShowTechnicianModal(true);
  };

  const handleDeleteTechnician = async (technicianId) => {
    try {
      const response = await axios.delete(
        `${BASE_URL}/users/tms_users/${technicianId}/`,
        {
          headers: {
            ...HEADERS,
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (response) {
        toast.success("Technician deleted successfully!");
        fetchTechnicians(currentPage);
      } else {
        toast.error("Failed to delete technician. Please try again.");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } else {
          toast.error("Unexpected error format. Please try again.");
        }
      } else {
        toast.error("Error Please Try again.");
      }
    }
  };

  const handleToggleActive = async (technicianId, currentStatus) => {
    try {
      const response = await axios.put(
        `${BASE_URL}/users/tms_users/${technicianId}/`,
        { is_active: !currentStatus },
        {
          headers: {
            ...HEADERS,
            "Content-Type": "application/json",
          },
        },
      );
      if (response.status === 200) {
        toast.success(
          `Technician ${
            currentStatus ? "deactivated" : "activated"
          } successfully!`,
        );
        fetchTechnicians(currentPage);
        fetchActiveTechnicians();
      } else {
        toast.error("Failed to update technician status. Please try again.");
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorData = error.response.data.error;

        if (typeof errorData === "object" && !Array.isArray(errorData)) {
          Object.entries(errorData).forEach(([field, messages]) => {
            if (Array.isArray(messages)) {
              messages.forEach((message) => {
                toast.error(`${message}`);
              });
            } else {
              toast.error(`${messages}`);
            }
          });
        } else {
          toast.error("Unexpected error format. Please try again.");
        }
      } else {
        toast.error("Error Please Try again.");
      }
    }
  };

  const handleCloseModals = () => {
    setShowTechnicianModal(false);
    setShowImportModal(false);
    setEditTechnicianData(null);
  };

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const handleViewUser = (techncician) => {
    setSelectedTechnicians(techncician);
    setShowViewModal(true);
  };

  const handleAddUser = () => {
    setEditTechnicianData(null);
    setShowTechnicianModal(true);
  };

  return (
    <div className="container-fluid">
      <div className="mt-3 d-flex container-header flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
        <h4 className="mb-md-0">Technician</h4>
        <div className="d-none d-md-flex align-items-center gap-2">
          <Form.Control
            type="text"
            value={searchText}
            className="uniform-input search-text"
            placeholder="Search Here..."
            onChange={(e) => setSearchText(e.target.value)}
          />

          <Form.Select
            value={
              statusFilter === true
                ? "is_active"
                : statusFilter === false
                  ? "!is_active"
                  : ""
            }
            onChange={(e) => {
              const value = e.target.value;
              if (value === "is_active") {
                setStatusFilter(true);
              } else if (value === "!is_active") {
                setStatusFilter(false);
              } else {
                setStatusFilter(null);
              }
            }}
            className="uniform-input"
          >
            <option value="is_active">Active</option>
            <option value="!is_active">Inactive</option>
          </Form.Select>

          <CommonButton className="uniform-button" onClick={handleAddUser}>
            <FaPlus style={{ marginRight: "6px" }} /> Add
          </CommonButton>

          <CommonButton
            className="uniform-button"
            onClick={() => setShowImportModal(true)}
          >
            <FaFileImport style={{ marginRight: "6px" }} /> Import
          </CommonButton>

          <CommonButton
            className="uniform-button"
            onClick={() => setShowExportModal(true)}
            disabled={exportLoading || currentItems.length === 0}
          >
            <FaFileExport style={{ marginRight: "6px" }} /> Export
          </CommonButton>
        </div>
        <div className="d-md-none w-100">
          <Accordion flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>Filters & Actions</Accordion.Header>
              <Accordion.Body className="pt-3">
                <Form.Control
                  type="text"
                  value={searchText}
                  className="uniform-input search-text mb-3"
                  placeholder="Search Here..."
                  onChange={(e) => setSearchText(e.target.value)}
                />

                <Form.Select
                  value={
                    statusFilter === true
                      ? "is_active"
                      : statusFilter === false
                        ? "!is_active"
                        : ""
                  }
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value === "is_active") {
                      setStatusFilter(true);
                    } else if (value === "!is_active") {
                      setStatusFilter(false);
                    } else {
                      setStatusFilter(null);
                    }
                  }}
                  className="uniform-input mb-3"
                >
                  <option value="is_active">Active</option>
                  <option value="!is_active">Inactive</option>
                </Form.Select>

                <div className="row g-2 mt-2">
                  <div className="col-12 col-sm-6 col-md-4">
                    <CommonButton
                      className="uniform-button w-100 d-flex justify-content-center align-items-center"
                      onClick={handleAddUser}
                    >
                      <FaPlus className="me-1" /> Add
                    </CommonButton>
                  </div>

                  <div className="col-12 col-sm-6 col-md-4">
                    <CommonButton
                      className="uniform-button w-100 d-flex justify-content-center align-items-center"
                      onClick={() => setShowImportModal(true)}
                    >
                      <FaFileImport className="me-1" /> Import
                    </CommonButton>
                  </div>

                  <div className="col-12 col-sm-6 col-md-4">
                    <CommonButton
                      className="uniform-button w-100 d-flex justify-content-center align-items-center"
                      onClick={() => setShowExportModal(true)}
                      disabled={exportLoading || currentItems.length === 0}
                    >
                      <FaFileExport className="me-1" /> Export
                    </CommonButton>
                  </div>
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      </div>

      <div
        className={`table-responsive ${
          currentItems.length === 0 ? "" : "tabell"
        } `}
      >
        {loading ? (
          <Loader />
        ) : (
          <>
            {currentItems.length > 0 ? (
              <table className="table    tstart ">
                <thead className="thead">
                  <tr style={{ whiteSpace: "nowrap" }}>
                    {/* <th style={{ width: "50px" }}>
                  <input
                    type="checkbox"
                    onChange={handleSelectAll}
                    checked={selectedTechnicianIds.length === currentItems.length}
                  />
                </th> */}
                    <th style={{ width: "350px" }}>Name</th>
                    <th style={{ width: "300px" }}>Email</th>
                    <th style={{ width: "200px" }}>Phone</th>
                    <th style={{ width: "200px" }}>Date of Joining</th>
                    <th style={{ width: "200px" }}>Casual Leaves</th>
                    <th style={{ width: "200px" }}>Sick Leaves</th>
                    <th style={{ width: "200px" }}>Punch-In Time</th>
                    <th style={{ width: "200px" }}>Punch-Out Time</th>
                    <th style={{ width: "150px" }}>Status</th>
                    <th style={{ width: "150px" }}>Latitude</th>
                    <th style={{ width: "150px" }}>Longitude</th>
                    <th style={{ width: "150px" }}>GPS Status</th>
                    <th style={{ width: "150px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((technician, index) => (
                    <tr
                      key={technician.id}
                      onClick={() => handleViewUser(technician)}
                      className="tbody"
                    >
                      {/* <td>
                    <input
                      type="checkbox"
                      checked={selectedTechnicianIds.includes(technician.id)}
                      onChange={() => handleSelectTechnician(technician.id)}
                      onClick={(e) => e.stopPropagation()}
                    />
                  </td> */}
                      <td>
                        <div className="d-flex align-items-center">
                          <span className="badge bg-primary text-white me-2 emp-id-badge">
                            {technician.emp_id || "—"}
                          </span>

                          {technician.profile_image ? (
                            <img
                              src={technician.profile_image}
                              alt="Profile"
                              className="rounded-circle border me-2"
                              style={{ width: "30px", height: "30px" }}
                            />
                          ) : (
                            <FaUserCircle
                              size={30}
                              className="text-primary me-2"
                            />
                          )}
                          <div
                            title={technician.first_name || "—"}
                            className="tdsubject"
                          >
                            {technician.first_name} {technician.last_name}
                          </div>
                        </div>
                      </td>
                      <td>
                        <div
                          title={technician.email || "—"}
                          className="tdsubject"
                        >
                          {technician.email || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={technician.phone_number || "—"}
                          className="tdsubject"
                        >
                          {technician.phone_number || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={technician.date_joined || "—"}
                          className="tdsubject"
                        >
                          {technician.date_joined || "—"}
                        </div>
                      </td>

                      <td>
                        <div
                          title={technician.allocated_casual_leave || "—"}
                          className="tdsubject"
                        >
                          {technician.allocated_casual_leave || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={technician.allocated_sick_leave || "—"}
                          className="tdsubject"
                        >
                          {technician.allocated_sick_leave || "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={
                            technician.today_attendance?.punch_in
                              ? formatTime(
                                  technician.today_attendance?.punch_in,
                                )
                              : "—"
                          }
                          className="tdsubject"
                        >
                          {technician.today_attendance?.punch_in
                            ? formatTime(technician.today_attendance?.punch_in)
                            : "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={
                            technician.today_attendance?.punch_out
                              ? formatTime(
                                  technician.today_attendance?.punch_out,
                                )
                              : "—"
                          }
                          className="tdsubject"
                        >
                          {technician.today_attendance?.punch_out
                            ? formatTime(technician.today_attendance?.punch_out)
                            : "—"}
                        </div>
                      </td>
                      <td>
                        {technician.today_attendance?.status || "NA"}
                        <br />
                        <span
                          className={`badge ${
                            technician.is_active ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {technician.is_active ? "Active" : "Inactive"}
                        </span>
                      </td>

                      <td>
                        <div
                          title={
                            technician.longitude
                              ? `${technician.longitude}`
                              : "—"
                          }
                          className="tdsubject"
                        >
                          {technician.longitude
                            ? `${technician.longitude}`
                            : "—"}
                        </div>
                      </td>
                      <td>
                        <div
                          title={
                            technician.latitude ? `${technician.latitude}` : "—"
                          }
                          className="tdsubject"
                        >
                          {technician.latitude ? `${technician.latitude}` : "—"}
                        </div>
                      </td>
                      <td>{technician.gps_status ? "On" : "Off"}</td>
                      <td>
                        <div className="ms-auto">
                          <DropdownButton
                            id="dropdown-basic-button"
                            title={<BsThreeDotsVertical />}
                            variant="link"
                            onClick={(e) => e.stopPropagation()}
                            className="p-0 text-secondary custom-dropdown"
                          >
                            <Dropdown.Item
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEditTechnician(technician);
                              }}
                            >
                              <FaEdit className="me-2" /> Edit
                            </Dropdown.Item>
                            {role === "admin" && (
                              <Dropdown.Item
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteTechnician(technician.id);
                                }}
                              >
                                <FaTrashAlt className="me-1" /> Delete
                              </Dropdown.Item>
                            )}
                            <Dropdown.Item
                              as="button"
                              onClick={() =>
                                handleToggleActive(
                                  technician.id,
                                  technician.is_active,
                                )
                              }
                            >
                              {technician.is_active ? (
                                <>
                                  <MdCancel className="me-2" /> Deactivate
                                </>
                              ) : (
                                <>
                                  <MdCheckCircle className="me-2" /> Activate
                                </>
                              )}
                            </Dropdown.Item>
                          </DropdownButton>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <NoData message="No Data Found" height="400px" />
            )}
          </>
        )}
      </div>

      {currentItems.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          handlePageClick={handlePageClick}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {showTechnicianModal && (
        <AgentModal
          show={showTechnicianModal}
          handleClose={handleCloseModals}
          agentData={editTechnicianData}
          roletype="technician"
          fetchAgents={() => fetchTechnicians(currentPage)}
        />
      )}

      <ExportModal
        show={showExportModal}
        handleClose={() => setShowExportModal(false)}
        title="technicians"
      />

      {showImportModal && (
        <ImportModal
          show={showImportModal}
          handleClose={handleCloseModals}
          type="technicians"
          onSuccess={() => fetchTechnicians(currentPage)}
        />
      )}

      <TechnicianViewModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        userId={selectedTechnicians?.id}
        user={selectedTechnicians}
      />
    </div>
  );
};

export default Technician;
